import { Type } from "ol/geom/Geometry";
import { Size } from "ol/size";

export interface IResult {
    //本次接口调用状态，如果成功返回0，如果失败返回其他数字。
    status: number;
    //对接口调用状态值的英文说明，如果成功返回"ok"，并返回结果字段，如果失败返回错误说明。
    message: string;
    //接口调用结果
    result?: any;
    //接口传入的参数
    params?: any;
}
export interface IResultCloudRender {
    //客户端id
    clientId?: string;
    //来源
    source?: number;
    //msgId
    msgId?: string;
    //时间戳
    timestamp?: number;
    //类型
    type?: number;
    data?: {
        //返回code 200-成功
        code: number;
        //方法名
        command: string;
        //信息
        msg: string;
        // data;
        data?: string;
    };
}
export enum Platforms {
    ArcGIS3D = "arcgis3d",
    ArcGIS2D = "arcgis2d",
    BDMap = "bd",
    BDMapGL = "bd_gl",
    AMap = "gd",
    PGIS_LS = "pgis",
    CesiumMap = "cesiumMap",
    CloudRenderMap = "CloudRenderMap",
    CloudRenderOpenLayer = "openLayer",
}
export interface ICenterLevelParams {
    x: number;
    y: number;
    duration: number;
    level: number;
    cameraId?: string; // camera的id（唯一）
    coordType?: string; //坐标类型(0:经纬度坐标，1:cad坐标)
    coordZ?: string; //高度(单位:米)
    armDistance?: string; // ue 臂长
    rotation?: Array<number>; //[翻滚,俯仰,偏航]
    fly?: string; //是否使用飞行动画(true:使用；false:不使用)
    flyTime?: string; //飞行动画时长(单位:秒)，默认为2秒
}
export interface IMapContainer {
    view?: any;

    // 三维相关
    setCameraInfo?: (params: any) => Promise<IResultCloudRender>;
    addAssetModel?: (param: IAssetModel) => Promise<IResult>;
    removeAssetModel?: (param: RemoveAss) => Promise<IResult>;
    closeClientWebsocket?: () => void;
    performExtendAction?: (params: any) => Promise<IResultCloudRender>;

    //路况图层
    addTileLayer?: () => Promise<IResult>;
    deleteTileLayer?: () => Promise<IResult>;
    setWebsocket?: () => Promise<any>;
    // 覆盖物
    addOverlays?: (param: IOverlayParameter) => Promise<IResult>;
    addOverlaysLine?: (param: IOverlayParameter) => Promise<IResult>;
    addOverlaysZHZX?: (param: IOverlayParameter) => Promise<IResult>;

    deleteOverlays?: (param: IOverlayDelete) => Promise<IResult>;
    deleteOverlaysLine?: (param: IOverlayDelete) => Promise<IResult>;
    deleteAllOverlays?: () => void;
    getOverlays?: (params: IOverlayDelete) => Promise<IResult>;
    hideOverlays?: (param: IOverlayDelete) => Promise<IResult>;
    showOverlays?: (param: IOverlayDelete) => Promise<IResult>;

    showToolTip?: (param: IOverlayDelete) => Promise<IResult>;
    hideToolTip?: (param: IOverlayDelete) => Promise<IResult>;

    addComponentOverlay?: (params: IComponentOverlayParam) => Promise<IResult>;
    deleteComponentOverlay?: (params?: IOverlayDelete) => IResult;

    addCustomComponentOverlay?: (params: IComponentOverlayParam) => Promise<IResult>;

    // 聚合点簇
    addOverlaysCluster?: (param: IOverlayClusterParameter) => Promise<IResult>;
    deleteOverlaysCluster?: (param: IOverlayDelete) => void;
    deleteAllOverlaysCluster?: () => void;

    // 热图
    addHeatMap?: (param: IHeatParameter) => Promise<IResult>;
    deleteHeatMap?: (params: ILayerConfig) => void;
    addHeatMapFromServer?: (param: IHeatMapParams) => Promise<IResult>;

    addHeatImage?: (params: IHeatImageParameter) => void;
    deleteHeatImage?: () => void;

    // Converts the given map point to a screen point.
    toScreen?: (params: { x: number; y: number }) => IResult;
    // Converts the given screen point to a map point.
    toMap?: (params: { x: number; y: number }) => IResult;

    // 图层开关
    showLayer?: (param: ILayerConfig) => void;
    hideLayer?: (param: ILayerConfig) => void;
    showRoad?: (param: { ids: string[] }) => void;
    hideRoad?: () => void;
    showStreet?: () => void;
    hideStreet?: () => void;

    // 控制建筑图层
    toggleBuildingLayer?: (visible: boolean) => void;

    // 控制svg/image图层
    showImage?: () => void;

    // 地图显示范围控制
    setMapCenter?: (param: IPointGeometry) => void;
    setMapCenterAndLevelZHZX?: (param: ICenterLevel) => Promise<void>;
    setMapCenterAndLevel?: (param: ICenterLevel) => Promise<void>;
    setMapLevel?: (params: IMapLevel) => Promise<void>;
    getMapLevel?: () => number;
    setMapCamera?: (param: ICamera) => void;
    setMapScaleFactor?: (factor: number) => Promise<void>;

    // 地图测量
    measure_length?: () => Promise<IResult>;
    measure_area?: () => Promise<IResult>;
    measure_clear?: () => void;

    // 警务辖区
    showJurisdiction?: () => void;
    hideJurisdiction?: () => void;
    showDistrictMask?: (param: IDistrictParameter) => void;
    hideDistrictMask?: () => void;

    // 搜索要素
    findFeature?: (param: IFindParameter) => Promise<IResult>;

    // 搜索要素
    findFeatureYp?: (param: IFindParameter) => Promise<IResult>;

    // 关闭要素高亮
    stopHighlightFeature?: () => void;

    // 街道定位
    locateStreet?: (param: IStreetParameter) => void;

    // 地图样式
    setMapStyle?: (style: string) => void;

    // 路径
    routeSearch?: (param: any) => Promise<IResult>;
    clearRouteSearch?: () => void;
    showRoutePoint?: (params: any) => void;
    clearRoutePoint?: () => void;
    searchShortestPath?: (param: IRouteParameter) => Promise<IResult>; //查找两点之间最短路径(要求arcgis api v4.19以上)
    clearShortestPath?: () => Promise<IResult>; //清除路径

    // 绘制要素
    addDrawLayer?: (params: any) => Promise<IResult>;
    clearDrawLayer?: (params: ILayerConfig) => void;

    // 图层展示部分
    showPart?: (params: ShowPartParameter) => void;
    // 取消图层展示部分
    showPartCancel?: (params: ShowPartCancelParameter) => void;

    // 画点、画线、画多边形
    startDrawOverlays?: (params: IDrawOverlays) => Promise<void>;
    // 停止绘制
    stopDrawOverlays?: () => Promise<void>;
    // 获取绘制结果、获取地图上所有绘制的覆盖物结果
    getDrawOverlays?: () => Promise<IResult>;
    // 删除绘制结果
    deleteDrawOverlays?: (params: IOverlayDelete) => Promise<void>;

    // 迁徙图表
    showMigrateChart?: (params: any) => void;
    showSubwayMigrateChart?: (params: any) => void;
    showODData?: (params: IODDataParams) => void;
    hideMigrateChart?: (params?: { custom: boolean }) => void;

    // 几何搜索
    startGeometrySearch?: (params: IGeometrySearchParameter) => Promise<IResult>;
    clearGeometrySearch?: () => void;

    // bar chart
    showBarChart?: (params: any) => void;
    hideBarChart?: () => void;

    // 要素弹框控制
    showPopup?: (params: IPopUpTemplate) => void;
    closePopup?: () => void;
    showCustomTip?: (params: ICustomTip) => void;

    // 叠境api
    addDgeneFusion?: (params: any) => Promise<IResult>;
    showDgeneOutPoint?: (params: any) => void;
    changeDgeneOut?: () => void;
    showDgene?: (params: any) => Promise<IResult>;
    hideDgene?: () => void;
    restoreDegeneFsion?: () => Promise<IResult>;

    //特勤线路相关
    initializeRouteSelect?: (params: ISelectRouteParam) => Promise<void>;
    showSelectedRoute?: (params: ISelectRouteResult) => Promise<void>;
    playSelectedRoute?: (speed: number) => Promise<void>;
    stopPlaySelectedRoute?: () => void;
    routeHitArea?: (params: ISelectRouteHitTest) => Promise<IResult>;
    areaHitRoute?: (params: ISelectRouteHitTest) => Promise<IResult>;

    startLayerSearch?: (params: IGeometrySearchParameter) => Promise<IResult>;
    startLayerDefinition?: (params: IDefinitionParameter) => Promise<void>;
    startTrackPlay?: (params: ITrackParameter) => Promise<void>;
    stopTrackPlay?: () => void;
    getRegionOverlays?: (params: IOverlayParameter) => Promise<IResult>;

    // sumo相关
    connectSumoSimulation?: (params: ISumoConnectInfo) => Promise<IResult>;
    disconnectSumoSimulation?: () => void;
    connectRealTimeSimulation?: (params: ISumoConnectInfo) => Promise<IResult>;
    disconnectRealTimeSimulation?: () => void;
    focusOnVehicle?: (id: string) => void;
    cancelFocusOnVehicle?: () => void;

    // 监视地图中心点，移到某些区域时通知页面
    toggleWatchMapFocus?: (params: { types: string[] }) => void;
    startWatchMapFocus?: () => Promise<void>;
    stopWatchMapFocus?: () => void;
    setMapFocus?: (focusInfo: { type: string; id: string; scaleFactor?: number }) => Promise<IResult>;

    // 监控用户操作地图
    startWatchMapCenter?: () => void;
    stopWatchMapCenter?: () => void;

    // 设置地图视角（arcgis）
    setMapViewpoint?: (viewpoint: __esri.Viewpoint) => void;

    //设置路口视角
    setCrossCamera?: (params: ICrossCamera) => void;
    clearCrossCamera?: () => void;

    // 动画点
    addAnimatePoints?: (params: IOverlayParameter) => Promise<IResult>;
    deleteAnimatePoints?: (params?: IOverlayDelete) => Promise<IResult>;

    //动画线
    addAnimateLines?: (params: IAnimateLineAddParams) => Promise<IResult>;
    deleteAnimateLines?: (params: IAnimateLineDelParams) => Promise<IResult>;

    // 设置路口信号箭头相位
    startSignalPhase?: (params: ISignalPhaseInfo) => Promise<IResult>;

    // 设置车道相位
    initializeLaneSignalPhase?: (crossId: string) => void;
    startLaneSignalPhase?: (laneSignalPhaseInfos: ILaneSignalPhaseInfo[]) => void;
    stopLaneSignalPhase?: (crossId: string) => void;
    stopAllLaneSignalPhase?: () => void;

    // 路口区域
    startDrawCrossRegion?: (params?: { tool?: string }) => Promise<IResult>;
    stopDrawCrossRegion?: () => void;
    startDeleteCrossRegion?: () => Promise<IResult>;
    stopDeleteCrossRegion?: () => void;
    showCrossRegions?: (params: { regions: Array<ICrossRegionInfo> }) => void;
    hideCrossRegions?: () => void;

    //切换widget组件隐藏显示
    toggleWidget?: (params: string[]) => void;
    setWidgetPos?: (params: Array<IWidget>) => void;

    setMinimapPosition?: (params: IPosition) => void;

    // 当前视野范围内有多少个路口
    queryCrossInView?: (params: ICrossInView) => IResult;
    clearCrossInView?: () => void;
    toggleLayerByYear?: (year: string) => void;

    addMiniMapPoints?: (params: IOverlayParameter) => void;

    initPassageWall?: (params: { roadUrl: string }) => Promise<IResult>;
    addPassageWall?: (params: IPassagewaysParam) => void;
    deletePassageWall?: () => void;

    addQueryIntersect?: (params: IQueryParameter) => void;
    deleteQueryIntersect?: (params: string | undefined) => void;

    // 定制交保路线
    route_initialize?: (params?: { cameraUrl: string; token: string; showRoad?: boolean }) => Promise<void>;
    route_addStartPoint?: () => Promise<IResult>;
    route_addMultiStartPoints?: () => Promise<IResult>;
    route_addEndPoint?: () => Promise<IResult>;
    route_addWayPoint?: (index: number) => Promise<IResult>;
    route_deleteWayPoint?: (index: number) => IResult;
    route_getRoute?: () => Promise<any>;
    route_showRoute?: (params: { strategy?: string; coordinates?: string; crossIds?: string[]; signalIds?: string[] }) => Promise<IResult>;
    route_clearRoutes?: () => Promise<void>;
    route_focusCross?: (crossId: string) => Promise<IResult>;
    route_play?: (speed: number) => void;
    route_stop?: () => void;
    route_pause?: () => void;
    route_resume?: () => void;
    route_routeHitArea?: (params: IRouteHitTestParam) => Promise<IResult>;
    route_areaHitRoute?: (params: IRouteHitTestParam) => Promise<IResult>;
    route_showHitResult?: (params: IRouteHitTestResultParam) => void;
    route_getMultiRoutes?: (params: IMultiStartRoute) => Promise<IResult>;

    //轨迹移动
    startTrackLine?: (params: ITrackLineParameter) => Promise<IResult>;
    stopTrackLine?: () => void;

    getMapOption?: () => Promise<IResult>;

    // 显示路口连成的车辆轨迹
    showCrossTrack?: (crosses: Array<ITrackCross>) => Promise<void>;
    hideCrossTrack?: () => void;

    // 高亮显示轨迹中的路口
    showCrossTrackHighlight?: (crossId: string) => void;

    clearArrowLayer?: () => void;
    test?: () => void;

    // 点集
    addPointCollection?: (params: IOverlayParameter) => Promise<IResult>;
    deletePointCollection?: (params: IOverlayDelete) => Promise<IResult>;
    findPointCollection?: (params: IFindParameter) => Promise<IResult>;

    // 动态图层
    dynamicLayer_initialize?: (configFile: string) => Promise<void>;
    dynamicLayer_show?: (params: IDynamicLayerDataParams) => Promise<void>;
    dynamicLayer_hide?: (params: IDynamicLayerDataParams) => void;

    // 选择要施工的车道
    selectLane_initialize?: () => Promise<void>;
    selectLane_getResult?: () => IResult;
    selectLane_showLanes?: (params: IShowSelectedLaneParam[]) => void;

    // json layer
    jsonLayer_add?: (params: ILayerConfig) => Promise<void>;
    jsonLayer_clear?: (params: ILayerConfig) => void;

    //设置地图控件
    setMapControl?: (params: IMapControlParam) => void;

    //关键字查找
    localSearch?: (params: IPOILocalSearchParameter) => Promise<IResult>;

    //坐标系转换
    transformCoordinates?: (params: ICoordinatesTransformParams) => IResult;

    // 置顶图层
    moveLayerToTop?: (params: { type: string }) => IResult;
    // 调整图层顺序
    reorderLayer?: (params: { type: string; order: number }) => IResult;
    
    // 切换地图底图
    changeBaseLayer?: (params: { LAYERS: string }) => IResult;
}
export interface RemoveAss {
    assetIds: Array<string>; //3d模型删除
}
export interface IAssetModel {
    // 以下为3D
    showRange?: string;
    //资产ID
    assetId?: string;
    //资产名称，优先用ID匹配资产，ID为空时用名称匹配，名称必须唯一
    assetName?: string;
    //资产类型 user:用户导入资产，store:官方资产库资产
    assetType?: string;
    //坐标类型(0:经纬度坐标，1:cad坐标)
    coordType?: number;
    //海拔高度(单位：米)
    coordZ?: number;
    //加载动画类型(gradiant:渐变；drop:掉落；none:无)，对性能有一定要求，数量较大	时建议设置为none
    animationType?: string;
    //动画完成时间(单位：秒)，animationType为none时无效
    animationDurationTime?: number;
    //中心点坐标 lng,lat
    center?: Array<number>;
    //镜头旋转参数 俯仰角(-90~90),航向角[0~360),镜头距中心点距离(单位:米)
    rotation?: Array<number>;
    //缩放倍数
    scale?: number;
    //模型选中特效(highlight:边框高亮；arrow:箭头指向；none:无)
    onSelectEffect?: string;
    // 模型是否显示
    visible?: boolean;
    //是否显示文本标签(true:显示；false:不显示)
    showLabel?: boolean;
}

export interface ICoordinatesTransformParams {
    origin: CoordinateType; //原坐标系
    target: CoordinateType; //目标坐标系
    coords: number[]; //坐标值
}

export interface ICoordinate {
    type: CoordinateType;
    wkid?: number;
}

export enum CoordinateType {
    BD09 = "bd09",
    BD09_MC = "bd09mc",
    WGS84 = "wgs84",
    GCJ02 = "gcj02",
}

export interface ILayerConfig {
    type?: string;
    label?: string | Array<string>;
    url?: string;
    visible?: boolean;
    subDomains?: Array<string>;
    toggleOther?: boolean;
    tileInfo?: any;
}

export interface IPointSymbol {
    scale: number;
    // scale: number | Size | undefined;
    // scale: number | undefined;
    type: string; //point-2d/point-3d
    //2D时为图片地址
    //3D时为模型地址
    url?: string;
    urlSingle?: string;
    fillColor?: string;
    strokeColor?: string;
    //使用图元时的图元类型
    //2D图元
    //"circle" | "square" | "cross" | "x" | "kite" | "triangle"
    //3D图元
    //"sphere" | "cylinder" | "cube" | "cone" | "inverted-cone" | "diamond" | "tetrahedron"
    primitive?: string;
    color?: string | number[]; //使用图元时的图元颜色
    outline?: {
        //使用图元时的图元边框
        size?: number;
        color?: number[] | string;
    };
    //[width, height, depth], number单位默认为pt, 可以使用'pt'或'px'
    //depth在point-3D时可用
    //size = 14; size = ["12pt", "14pt"]
    size?: Array<number | string> | number | string;
    //锚点
    //"center" | "left" | "right" | "top" | "bottom" | "top-left" | "top-right" | "bottom-left" | "bottom-right"
    anchor?: string;
    //旋转角度，在point-3d时代表[x轴角度, y轴角度, z轴角度]
    //在point-2d时代表中心旋转角度
    rotation?: Array<number> | number;
    width?: number | string;
    height?: number | string;
    xoffset?: number | string;
    yoffset?: number | string;
    arrow?: {
        color?: number[] | string;
        width?: number;
        size?: number;
        space?: number;
    };
}

export interface IPolylineSymbol {
    scale: number;
    // scale: number | Size | undefined;
    type: string; //line-2d/line-3d
    isoutline?: boolean;
    outlineColor?: string;
    borderWeight?: number;
    color?: string;
    opacity?: number;
    width?: number;
    style?: "solid" | "dashed" | undefined;
    dashArray?: [number, number] | [number, number, number, number] | undefined;
    lineJoin?: "miter" | "bevel" | "round" | undefined;
    lineCap?: "round" | "butt" | "square" | undefined;
    zIndex?: number;
    size?: number;
}

export interface IPolygonSymbol {
    scale: number;
    // scale: number | Size | undefined;
    type: string;
    outline: IPolylineSymbol;
    color?: string;
    opacity?: number;
    zIndex?: number;
}

export interface IPointGeometry {
    x: number;
    y: number;
    x_cj?: number; //城建坐标
    y_cj?: number; //城建坐标
    z?: number;
    duration?: number;
}

export interface IPolylineGeometry {
    path: Array<IPointGeometry>;
}

export interface IPolygonGeometry {
    ring: Array<IPointGeometry>;
}

export interface ICircleGeometry {
    center: Array<number>;
    radius: number;
}

export interface ICenterLevel {
    x: number;
    y: number;
    level?: number;
    cameraId?: string; // camera的id（唯一）
    coordType?: string; //坐标类型(0:经纬度坐标，1:cad坐标)
    coordZ?: string; //高度(单位:米)
    armDistance?: string; // ue 臂长
    rotation?: Array<number>; //[翻滚,俯仰,偏航]
    fly?: string; //是否使用飞行动画(true:使用；false:不使用)
    flyTime?: string; //飞行动画时长(单位:秒)，默认为2秒
    duration?: number;
}

export interface IMapLevel {
    level?: number;
    factor?: number;
    animate?: boolean;
    duration?: number;
}

export interface ICamera {
    position?: number[];
    heading?: number;
    tilt?: number;
    duration?: number;
}

export interface IOverlay {
    id?: string; //覆盖物编号, 用于按编号/类型删除
    type?: string; //覆盖物类型, 用于按编号/类型删除
    symbol?: IPointSymbol | IPolylineSymbol;
    style?: any; //用于确定覆盖物样式（pgis），优先级高于symbol
    geometry: IPointGeometry | IPolylineGeometry | IPolygonGeometry | ICircleGeometry;
    fields?: any; //覆盖物的属性字段
    zooms?: [number, number];
    buttons?: string[];
}

export interface IOverlayParameter {
    defaultType?: string;
    type?: string;
    defaultSymbol?: IPointSymbol | IPolylineSymbol;
    defaultZooms?: [number, number];
    defaultZoom?: number;
    showTooltip?: any;
    moveTooltip?: any;
    movePopup?: any;
    overlays: Array<IOverlay>;
    autoPopup?: boolean;
    showPopup?: boolean; //是否显示popup
    defaultInfoTemplate?: IPopUpTemplate;
    defaultButtons?: Object[];
    showToolTip?: boolean; //鼠标移到该点位是，是否显示悬浮窗
    toolTipContent?: string; //悬浮窗内容
    defaultVisible?: boolean;
    iswgs?: boolean;
    custom?: {
        content: string;
        zooms: [number, number];
        visible: true;
        anchor: string;
        yoffset: number;
        fontSize: string;
        fontColor: string;
    };
    coords?: string; //定义撒点坐标系
    showRegion?: boolean;
    miniMapView?: __esri.MapView;
    showInMiniMap?: boolean;
    showInMainMap?: boolean;
    animateType?: string;
    crossIds?: Array<string>;
    centerResult?: boolean;
    transform?: any;
    tooltipComponent?: any;
    popupComponent?: any;
    autoTooltip?: any;
    level?: number;
    layerIndex?: number;
    triggerMouseover?: boolean; //是否为覆盖物添加mouseover事件的触发响应,默认true
    triggerMouseout?: boolean; //是否为覆盖物添加mouseout的触发响应,默认true
    triggerClick?: boolean; //是否为覆盖物添加click事件的触发响应,默认true
    topLeft?: VisualArea; //存放可视区域的左上角
    bottomRight?: VisualArea; //存放可视区域的右下角
    dataList?: Array<IOverlay>; //保存过滤后的点位
    allOverLayerStatus?: boolean; //百度地图专用 控制撒点个数
    toolTipZoom?: number; //百度专用 控制图例在不同层级的时候显示隐藏
    // 3D相关如下

    //显示距离范围(单位：米，范围最小、最大距离；在此范围内显示，超出范围隐藏)
    showRange?: string;
    //坐标类型(0:经纬度坐标，1:cad坐标)
    coordType?: number;
    //动画类型(bounce:弹出；stretch:伸缩；wipe:展开；none:无)，对性能有一定要求，点位数量较大时建议设置为none
    animationType?: string;
    //动画完成时间(单位：秒)，animationType为none时无效
    animationDurationTime?: number;
    //是否显示点位图标(true:显示；false:不显示)
    showImage?: boolean;
    //是否显示文本标签(true:显示；false:不显示)
    showLabel?: boolean;
    //点位风格定义
    imageStyle?: {
        //点位图片引用类型(local:本地引用；remote:远程引用)
        imageRefType?: string;
        //点位图片链接地址，imageRefType为remote生效
        imageUrl?: string;
        //点位图片文件路径，imageRefType为local生效
        imagePath?: string;
        //点位图片大小(宽，高，单位：像素)
        imageSize: Array<number>;
    };
    //标签风格定义
    labelStyle?: {
        //点位文本标签背景大小(宽，高，单位：像素)
        bgSize?: Array<number>;
        //点位文本标签背景图片引用类型(local:本地引用；remote:远程引用；none:不使用图片背景)
        bgImageRefType?: string;
        //点位图片链接地址，bgImageRefType为remote生效
        bgImageUrl?: string;
        //点位图片文件路径，bgImageRefType为local生效
        bgImagePath?: string;
        //点位文本标签背景颜色(HEXA)
        bgColor?: string;
        //点位文本标签背景边框颜色(HEXA)
        bgCornerColor?: string;
        //点位文本标签背景边框线宽(单位:像素，0为无边框)
        bgCornerWidth?: number;
        //点位文本标签背景框角半径(单位:像素，0为直角)
        bgCornerRadius?: number;
        //文本对齐方式(left:左；center:中；right:右)，默认为center
        textAlign?: string;
        //文本字体颜色
        textColor?: string;
        //文本字体大小
        textSize?: string;
        //文本标签相对点位中心点的偏移(x,y，单位：像素，x为正向右，y为正向上)
        offset?: Array<number>;
        //文本长度超出宽度时滚动速度，为0时不滚动
        textScrollSpeed?: number;
        //点击响应事件(window:在点位上方弹出信息窗，信息窗内容由window参数声明；web:通知web端点击事件及点击对象点位信息；none:不处理)
    };
    onClickResponseType?: string;
    window?: {
        //弹窗HTML引用类型(local:本地引用；remote:远程引用)
        htmlRefType?: string;
        //弹窗HTML链接地址，htmlRefType为remote生效
        htmlUrl?: string;
        //弹窗HTML文件路径，htmlRefType为local生效
        htmlPath?: string;
        //弹窗大小(宽，高，单位：像素)
        size?: Array<number>;
        //弹窗左上角相对marker中心点的偏移(x,y，单位：像素，x为正向右，y为正向上)
        offset?: Array<number>;
        //是否将点位信息作为URL参数传递给HTML页面(true:传递；false:不传递)，默认为true
        useMarkerInfoAsUrlParam?: boolean;
    };
    markers?: [
        {
            id?: string;
            //点位名称
            name?: string;
            //点位文本标签
            label?: string;
            //点位图层类型
            type?: string;
            //海拔高度(单位：米)
            coordZ?: number;
            //中心点坐标 lng,lat
            center?: Array<number>;
        }
    ];
}

export interface IOverlayClusterParameter {
    minDistance: number | undefined;//最小距离（仅适用于Openlayers）
    showRegion?: boolean; //显示聚合展开后的包含范围
    points?: Array<IOverlay>; //所有撒点
    overlays?: Array<IOverlay>; //所有撒点 （同points）
    type: string; //聚合点类型（会生成此类型的图层）图层label,聚合点图片类型
    zoom: number; //发生聚合的最大缩放
    custom?: any; //撒点的自定义文本（仅适用于arcgis）
    ispic?: boolean; //（仅适用于arcgis）（废弃）
    distance: number; //发生聚合的最大距离
    showPopup?: boolean; //撒点冒泡框(仅适用于baidu)
    defaultInfoTemplate?: IPopUpTemplate; //撒点冒泡框(仅适用于baidu)
    defaultSymbol?: IPointSymbol; //默认图标
    clusterSymbol?: IPointSymbol; //聚合点的图标符号
    defaultVisible?: boolean; //聚合点是否可见（仅适用于arcgis）
    defaultTooltip?: string; //撒点冒泡框(仅适用于arcgis)
    subType?: string; //用于聚合计数的类型（仅适用于arcgis）
    textStyle: any; //聚合点上的数字文本样式
    coords?: string; //转换撒点坐标系（仅适用于baidu）
    clusterDisplay?: boolean; //点击聚合点是否展开（仅适用于arcgis）
    topLeft?: VisualArea; //存放可视区域的左上角
    bottomRight?: VisualArea; //存放可视区域的右下角
    offsetX?: number;//文本偏移量（仅适用于Openlayers）
    offsetY?: number;//文本偏移量（仅适用于Openlayers）
    disabledZoomIn?: boolean;//控制点击聚合点是否可放大地图
}
export interface VisualArea {
    latitude: Number;
    longitude: Number;
}

export interface IPicChangeParameter {
    type?: string;
    id: string;
    pictureUrl: string;
    callback?: boolean;
    isSelected?: boolean;
}

export interface IPopUpTemplate {
    title?: string;
    content: string;
    fields?: any;
}

export interface IHeatParameter {
    points: Array<IHeatPoint>;
    options: IHeatOptions;
    label?: ""; //用于删除
}

//热图参数（since v0.6.333)
export interface IHeatMapParams {
    url: string; //热图数据源
    field?: string; //数据源中的权重字段
    label?: string; //热图图层标签
}

export interface IHeatImageParameter {
    points?: Array<IHeatPoint>;
    options?: IHeatOptions;
    images?: {
        url: string;
        width: number;
        heigth: number;
        center: { x: number; y: number }; //图片中心位置
        factor: number; //图片显示倍率
        scale?: number; //图片显示比例
        geometry: { x: number; y: number };
    };
}

export interface IHeatOptions {
    field: string;
    opacity?: number;
    radius?: number;
    colors?: Array<string>;
    maxValue?: number;
    zoom?: number;
    maxZoom?: number;
    minZoom?: number;
    blur?: number;
    renderer?: any;
    shrink?: boolean; //除去同位置点
}

export interface IHeatPoint {
    fields: any;
    geometry: IPointGeometry;
}

export interface IFindParameter {
    layerName: string;
    ids: Array<string>;
    level?: number;
    centerResult?: boolean;
    showPopUp?: boolean;
    xoffset?: number;
    yoffset?: number;
    layerids?: Array<string>;
    fields?: any;
    animation?: boolean;
    style?: string;
    factor?: number;
    color?: string | Array<number>;
    callback?: boolean;
    repeatCount?: number;
    highLightOption?: {
        color?: string; //边线颜色
        width?: number; //边线宽度
        style?: "dash" | "solid"; // 边框样式
        fillcolor?: string; // 填充的颜色
    };
    noJump?: boolean; //是否关闭撒点的跳跃动画，默认false
}

export interface IDefinitionParameter {
    layerName: string;
    searchNames: Array<string>;
    displayField?: string;
    searchField?: string;
    dataSource?: {
        url?: string;
        data?: any;
        joinField?: string;
        dataField?: string;
    };
    showLabel: boolean;
    url?: string;
    visible?: boolean;
    tips?: Array<any>;
    expand: boolean;
    factor?: number;
    xoffset?: number;
    yoffset?: number;
}

export interface IOverlayDelete {
    types?: Array<string>;
    ids?: Array<string>;
    miniMapView?: __esri.MapView;
    animateType?: string;
    id?: string;
}

export interface IDistrictParameter {
    name: string;
    city?: string;
    showMask?: boolean;
}

export interface IStreetParameter {
    id: string;
    name: string;
    hideStreet: boolean; //是否隐藏其他街道
    reset: boolean; //重置,清除选择
}

export interface IRouteParameter {
    start: IPointGeometry | number[]; //路径起点
    end: IPointGeometry | number[]; //路径终点
    waypoints: IPointGeometry[] | number[][];
    defaultSymbol?: IPointSymbol;
    model: string; //"car","ride","walk"
    changeRoute?: string;
    serverAddr?: string;
    showLine?: boolean;
    lineColor: string; //路径颜色 ,default: "rgb(0,0,255,0.5)"
    lineWidth: Number; //路径宽度 ,default: 4
    onlyLine?: boolean;
    paths?: number[][];
    id?: string;
    lineStyle?: IPointSymbol | IPolylineSymbol;
    showGisPoint?: boolean;
}

export interface IGeometrySearchParameter {
    types?: Array<string>; //搜索点位类型,默认搜索全部

    drawType?: string; //作画方式: "point" | "polygon" | "rectangle" | "circle", 默认point
    drawSymbol?: any; // 作画符号 (未统一)
    radius?: number; //搜索半径,单位米。（当drawType:"point"时有效，默认1000）
    center?: Array<number>; //搜索中心[lng,lat]。（当drawType:"point"时有效，且可选）

    clickHandle?: any; //查询结束,回调方法（pgis暂不支持）

    targetSymbol?: any; //替换查找结果点位的图标符号(支持bd/arcgis2d/pgis) {url,width,height,size[2]}

    showResult?: boolean; //是否只显示搜索结果，隐藏其他撒点（仅arcgis）
    showGeometry?: boolean; //是否显示搜素区域（仅arcgis\gd）
    centerResult?: boolean; //是否定位到中心（仅arcgis）
    repeat?: boolean; //是否重复点击画圆（仅arcgis\gd)
    geometry?: any; //用于搜索撒点的几何图形（仅arcgis\gd）
    geometryList?: any; //自定义搜索图形的点位list
    zoom?: number; //显示搜索结果时的层级;（仅arcgis）
    graphic?: any; //(非传参)（仅arcgis）

    key?: string;
    layerName?: string; //搜索图层
    maxLen?: number;
    animate?: boolean; //搜索结果是否显示动画(仅pgis)
    allMap?: boolean; // 几何查找是否包含所有图层（仅arcgis）（默认false）
}

export interface ICustomTip {
    prop: any;
    clear: boolean;
    geometry: IPointGeometry;
    class?: string;
    bubble?: boolean; //事件是否冒泡到地图上,如果为true,地图点击失效,如果为false,元素点击失效
}
// 图层展示部分-ArcGIS服务
export interface ShowPartParameter {
    lebel: any; //图层唯一标识
    key: any; //筛选属性
    value: any; //筛选值
    symbol: any; //筛选样式
    iconUrl?: any;//
    // name: any; //展示图层名称取值字段
}
// 取消图层展示部分-ArcGIS服务
export interface ShowPartCancelParameter {
    lebel: any; //图层唯一标识
    name?: any; //展示图层名称
    key: any; //筛选属性
    value: any; //筛选值
}
// 画点、画线、画多边形
export interface IDrawOverlays {
    drawTypeOl: Type; //绘制类型-Openlayers "Point" | "LineString" | "Polygon"
    drawType: string; //绘制类型 "point" | "multipoint" | "polyline" | "polygon" | "rectangle" | "circle"  
    model?: string; //绘制模式，默认 “add”
    id?: string; //覆盖物id，若没有传入则自动生成一个id
    type?: string; //覆盖物类型
    symbol?: any; //覆盖物的符号样式 (暂未统一，具体看不同接口)
    callback?: any; //回调函数，传入绘制结果对象
    update?: boolean; //画完的图形是否可以编辑
    repeat?: boolean; //画完是否继续画

    fields?: any; //存储一些属性字段到绘制的覆盖物中。（暂未使用）

    //================以下为不推荐使用的参数（只为兼容老版本）==================///
    defaultSymbol?: IPointSymbol | IPolylineSymbol | IPolygonSymbol; //默认符号
    showPopup?: boolean; //是否显示弹出
    showTooltip?: boolean; //是否显示覆盖物上的提示框
    generateId?: boolean; //是否随机生成覆盖物编号, 用于按编号/类型删除
    clearLastResult?: boolean; //清除上一次绘画结果（调用一次方法只能存在一个graphic）
    onlyOnce?: boolean; //与repeat含义相同
    enableCalculate?: boolean; //对于polyline和polygon是否计算面积，仅支持百度地图
}

export interface IDrawOverlaysDelete {
    ids?: string[];
    types?: string[];
}

export interface IDrawOverlayParameter {
    drawType: string;
    symbol?: IPointSymbol | IPolylineSymbol | IPolygonSymbol;
    defaultSymbol?: IPointSymbol | IPolylineSymbol | IPolygonSymbol;
    showPopup?: boolean;
    showTooltip?: boolean;
    id?: string;
    type?: string; //覆盖物类型, 用于按编号/类型删除
    generateId?: boolean; //是否随机生成覆盖物编号, 用于按编号/类型删除
    clearLastResult?: boolean; //清除上一次绘画结果（调用一次方法只能存在一个graphic）
    onlyOnce?: boolean;
    repeat?: boolean; //画完是否继续画
    callback?: any;
    enableCalculate?: boolean;
}

export interface ISelectRouteParam {
    enableXHJ?: boolean;
    roadUrl?: string;
    trafficSignalUrl?: string;
    symbol?: any;
    showRoad?: boolean;
    showSignal?: boolean;
}

export interface ISelectRouteResult {
    autoStart?: boolean; // 显示选路结果时是否自动开始轨迹演示
    routeInfo: {
        // 路段信息
        ids: Array<string>;
        length?: number;
        startPoint?: [number, number];
        endPoint?: [number, number];
    };
    signalInfo?: {
        // 信号机信息
        signals: Array<{
            id: string;
            name?: string;
            x?: number;
            y?: number;
            distance?: number;
        }>;
    };
}

export interface ISelectRouteHitTest {
    showRoute?: boolean;
    routes: [
        {
            id?: string;
            routeIds: Array<string>;
        }
    ];
    showArea?: boolean;
    areas: [
        {
            id?: string;
            name?: string;
            points: Array<Array<number>>;
        }
    ];
}

export interface IRouteHitTestParam {
    routes: [
        {
            id: string;
            points: string;
        }
    ];
    areas: [
        {
            id: string;
            name: string;
            points: Array<Array<number>>;
        }
    ];
}

export interface IRouteHitTestResultParam {
    routeIds?: Array<string>;
    areaIds?: Array<string>;
}

export interface ITrackParameter {
    id?: string;
    overlays: Array<any>;
    showPoint: boolean;
    repeat: number;
    callback: any;
    move?: boolean;
}

export interface ISumoConnectInfo {
    url: string;
    protocol?: string;
    crossId: string;
    guid?: string;
}

export interface IVehicleTrack {
    id: string;
    time: number;
    x: number;
    y: number;
    // 速度向量，xy方向上的速度
    vel?: Array<number>;
    color?: string | number[];
    icon?: string;
    plateColor?: string | number[];
    angle?: number;
    size?: string;
    speed?: number;
    showName?: string;
}

export interface IPassageway {
    id?: string;
    crossId: string;
    type?: string;
}

export interface IPassagewaysParam {
    ways: Array<IPassageway>;
    show?: boolean;
}

export interface ICrossInfo {
    id: string;
    name?: string;
    position: Array<number>;
    type?: string;
}

export interface IHopInfo {
    origin: ICrossInfo;
    destination: ICrossInfo;
    line: __esri.Polyline;
}

/**
 * crossId: 路口id
 * phase: 相位
 * totalPeriod: 总时长。为0则锁定此相位，不倒计时。
 * currentPeriod: 可选。当前相位剩余时长,默认按总时长算。
 * yellowPeriod: 可选。黄闪时长，默认3s。
 * redPeriod: 可选。全红时长，默认2s。
 * forceJump: 可选。true则中断当前相位，立即跳到此相位；false则等当前相位走完以后再跳。默认false。
 */
export interface ISignalPhaseInfo {
    crossId: string;
    phase: string;
    totalPeriod: number;
    currentPeriod?: number;
    yellowPeriod?: number;
    redPeriod?: number;
    forceJump?: boolean;
    showCenter?: boolean;
}

export interface ILaneSignalPhaseInfo {
    // 车道号，参数一样的车道可以传多个，逗号分开
    laneIds: string;
    // 灯色，r/g
    color: string;
    // 剩余时间
    time: number;
    // 黄闪时间，默认3秒，绿灯时有效
    yellowPeriod?: number;
    // 全红时间，默认2秒，绿灯时有效
    allRedPeriod?: number;
    // forceJump: 可选。true则中断当前相位，立即跳到此相位；false则等当前相位走完以后再跳。默认false。
    forceJump?: boolean;
}

/**
 * crossId: 路口id
 * phase: 相位
 * lockedPhaseId: 锁定的相位。
 * greenTime: 绿灯持续时间。
 * phaseElapsedTime: 当前相位运行时间.
 * greenFlash: 绿闪时间.
 * yellowTime:黄灯时间,闪烁.
 * currentPhaseInterval,当前相位当前阶段,绿灯,绿闪,黄灯,红灯
 * redPeriod: 可选。全红时长，默认2s。
 * forceJump: 可选。true则中断当前相位，立即跳到此相位；false则等当前相位走完以后再跳。默认false。
 */
export interface ISignalPhaseStateInfo {
    crossId: string;
    phaseId: string;
    lockedPhaseId: string;
    greenTime: string;
    phaseElapsedTime: string;
    greenFlash: string;
    yellowTime: string;
    currentPhaseInterval: string;
    yellowPeriod?: number;
    redPeriod?: number;
    forceJump?: boolean;
}

export interface ICrossRegionInfo {
    id: string;
    border?: Array<Array<number>>;
    crosses: Array<{ id: string; type: string }>;
    routes?: Array<IPassageway>;
}

export interface IPosition {
    right?: string;
    left?: string;
    top?: string;
    bottom?: string;
}

export interface ICrossCamera {
    position?: number[];
    heading?: number;
    tilt?: number;
    duration?: number;
    crossId?: string;
    type?: string;
    showCenter?: boolean; //是否定位到中心
    showQueue?: boolean; //是否显示排队长度
    showPhase?: boolean; //是否显示相位
    showPanel?: boolean; //是否显示视频面板
    banMove?: boolean; //是否禁止鼠标拖拽
}

export interface ICrossInView {
    showPoint?: boolean;
}

export interface IQueryParameter {
    label: string; //图层名称
    points: Array<IOverlay>; //点图层
    tooltip?: any; //弹窗
}

// 交保线路信息
export interface IJBRouteResult {
    strategy?: string;
    distance: number;
    duration: number;
    crosses: Array<{
        id: string;
        name: string;
        signal?: { id: string; name: string };
        camera?: { id: string; name: string };
    }>;
    coordinates: string;
}

export interface ITrackLineParameter {
    startPoints: Array<number>;
    endPoints: Array<number>;
    eventId?: string;
    QBBIds?: Array<string>;
    iswgs?: boolean; //传入的坐标是否为经纬度坐标
}

// 轨迹路口
export interface ITrackCross {
    id: string;
    delay?: number;
    phaseDirection?: string;
    routeState?: string;
}

export interface IWidget {
    name: string;
    config?: any;
    visible?: boolean;
}

export interface IMultiStartRoute {
    startPoints: Array<Array<number>>;
    endPoint: Array<number>;
    wayPoints?: Array<Array<number>>;
}

export interface IPolylineRangingParameter {
    type?: string;
    lineSymbol?: IPolylineSymbol; //测距线符号样式
    callback?: boolean; //是否后台返回测距结果
    unit?: string; //测距单位
    secSymbol?: any; //转折点symbol
    closeSymbol?: any; //结尾关闭点symbol
    startLayerSearch: (params: IGeometrySearchParameter) => Promise<IResult>;
    startLayerDefinition: (params: IDefinitionParameter) => Promise<void>;
    startTrackPlay: (params: ITrackParameter) => Promise<void>;
}

export interface IPOISearch {
    searchType: string; // 查询方式 rectangle/circle/region
    searchName: string; // 查询名称
    searchTag?: string; // 查询分类，用于筛选查询结果
    searchPage?: number; // 当查询结果较多时，可以设置查询页面继续查询
    city?: string;
    district?: string;
    location?: number[]; // circle search center
    radius?: number; // circle search radius
    region?: string; // region search cityName
    bounds?: number[]; // rectangle search bounds coordinates
    scope?: boolean; // 是否显示详细信息
    addResults?: boolean; // 是否将结果添加到地图上
    resultsUrl?: string; // 显示结果图片的url地址
    type?: string; // 显示结果点位的type值
    serverAddr?: string;
    paths?: number[][];
}

export interface IPOILocalSearchParameter {
    key: string | Array<string>; //关键字，或者关键字数组
    callback: any; //搜索结果的回调方法
    pageCapacity?: Number; //分页查询结果每页容量，默认10
    pageIndex?: Number; //第pageIndex的查询结果，默认0
    range?: string | IPointGeometry | ICircleGeometry; //搜索范围：城市名、中心点、圆形范围
}

export interface IPOIDelete {
    types?: string[];
    ids?: string[];
    exceptId?: string;
}

export interface IRoadNetwork {
    searchName: string;
    province?: string;
    city?: string;
    addResults?: boolean;
    symbol?: {
        color: string;
        width: number;
    };
    type?: string;
    id?: string;
    serverAddr?: string;
}

export interface IBoundary {
    searchName: string;
    adcode?: number | string;
    addResults?: boolean;
    color?: string;
    id?: string;
    type?: string;
    outline?: {
        color: string;
        width: number;
    };
    contains?: boolean; //是否包含下级单位
    centerResult?: boolean;
    defaultZoom?: number; //默认缩放等级
    serverAddr?: string;
}

export interface IJurisdiction {
    orgCode: number;
    // orgCode: string;
    subJurisdiction?: boolean;
    boundary?: boolean;
}

export interface IMultiBoundary {
    searchNames: string[];
    defaultZoom?: number;
    serverAddr?: string;
}

export interface IGeocode {
    address: string;
}

export interface IReverseGeocode {
    location: number[];
    radius?: number;
    poiTypes?: string[]; //hotel,road...
    serverAddr?: string;
    buffer?: number;
    pageIndex?: number;
    pageSize?: number;
}

export interface IRoutePlan {
    origin: number[];
    destination: number[];
    midPoints?: number[][];
    changeRoute?: string; // shortest time/shortest distance
    avoidArea?: {
        areaType: string;
        center?: number[];
        radius?: number;
        coordinates: number[];
    }; // 圆：[x,y,radius]/矩形：[x1,y1,x2,y2]
    mode?: string; //CAR,BICYCLE,WALK
    serverAddr?: string;
}

export interface IPOISearchPGIS {
    searchLayer?: string[] | undefined;
    searchName: string;
    orgCode?: number | undefined;
    searchPage?: number | undefined;
    searchSize?: number | undefined;
    searchBounds?: number[] | undefined;
    searchType?: string | undefined;
    searchCoords?: string | undefined;
}

export interface IDataRequestPNV {
    requestUrl?: string;
    deviceTypeNo: number;
    pageSize?: number;
    pageIndex?: number;
}

export interface IDataRequestCIM {
    requestUrl?: string;
    pageIndex?: number; //第几页
    pageSize?: number; //每页显示多少条数据
    projectTypeId?: string; //工程项目类型
    projectName?: string; //工程项目名称
    approvalTypeId?: string; //审批类型
    applyItemId?: string; //申请事项
    occupyTypeId?: string; //占道类型
    approvalStateId?: string; //审核状态
    applyUnit?: string; //施工单位
    manageDeptId?: string; //所属辖区大队
    startApplyTime?: string; //申请时间起
    endApplyTime?: string; //申请时间止
    isWriteOff?: boolean; //是否显示已核销数据,
    constructionTime?: string; //当前时间
}

export interface IDataRequestPark {
    requestUrl?: string;
}

export interface IDynamicLayerDataParams {
    name: string;
    datas?: { id: string; data: string }[];
    defaultData?: string;
}

export interface IShowSelectedLaneParam {
    fromCrossId: string;
    toCrossId: string;
    gisLanes: string[];
    distance2UpCross: number;
    length: number;
}

export interface IComponentOverlayParam {
    type?: string;
    vue?: any;
    anchor?: string;
    xoffset?: number;
    yoffset?: number;
    overlays: Array<{
        vue?: any;
        x: number;
        y: number;
        id?: string;
        type?: string;
        props?: any;
        anchor?: string;
        xoffset?: number;
        yoffset?: number;
    }>;
    zoomRange?: Array<number>; // vue组件在指定地图层级中显示；默认全层级显示
}

export interface IMapControlParam {
    type: string; //控件类型: "scale" | "zoom" | "navigation"
    anchor?: string; //停靠位置:"top-left" | "top-right" | "bottom-left" | "bottom-right"
    visible?: boolean; //是否显示
    ///配置控件的可选属性
    options?: {
        unit?: string; //比例尺单位："metric" | "non-metric"，arcgismap多支持一种："dual"
        ///------仅作用于arcgis地图---------------
        layout?: string; //缩放控件的摆放方向
        scaleStyle?: string; //比例尺控件的样式"ruler" | "line"
        ///------仅作用于baidu地图----------------
        xoffset?: number; //x偏移
        yoffset?: number; //y偏移
        remove?: boolean; //是否从DOM中移除控件
        //-以下为缩放控件专属--
        naviType?: string; //平移缩放控件的类型:"large" | "small" | "pan" | "zoom"
        showZoomInfo?: boolean; //是否显示级别提示信息
        enableGeolocation?: boolean; //控件是否集成定位功能，默认为false
    };
}

export interface ITrackPlaybackParameter {
    trackPoints: [
        {
            id?: string;
            from: number[];
            to: number[];
            time?: number;
            stage?: string;
        }
    ];
    moverType?: string; //"constant" || "bySecond"
    trackLineSymbol?: IPolylineSymbol;
    autoStart?: Boolean;
    loop?: Boolean;
    repeatCount?: number;
    clearBefore?: Boolean;
    isCenter?: Boolean;
    isZoom?: Boolean;
    routeUrl?: string;
    canSuspend?: Boolean;
}

export interface ITrackPlaybackBDParameter {
    trackPoints: number[][];
    moverType?: string; //"constant" || "bySecond"
    defaultLineSymbol?: IPolylineSymbol;
    defaultCarSymbol?: IPointSymbol;
    intervalTime?: number;
    loopTimes?: number;
    autoStart?: Boolean;
    loop?: Boolean;
    repeatCount?: number;
    clearBefore?: Boolean;
    isCenter?: Boolean;
    isZoom?: Boolean;
    routeUrl?: string;
    canSuspend?: Boolean;
    speed?: number;
    adjustPicRotation?: number; //在计算角度的基础上，适当调整图片的旋转角度
}

export interface ITrackPlaybackPGIS {
    trackPoints: number[][];
    trackLineSymbol?: IPolylineSymbol;
    carSymbol?: IPointSymbol;
    speed?: number;
    loop?: boolean;
}

export interface ITrackPlayback {
    features?: __esri.Graphic[];
    startId?: number;
    endId?: number;
    movingLength?: number;
    time: number;
    speed: number; //小车实际速度，单位m/s
    speedToString?: string; //速度字符串形式，取三位小数
    speedRatio?: number; //各路段小车速度与最小速度的比率
    path: number[][];
    stage?: string;
}

export interface IPicStatusUrl {
    online: string;
    offline: string;
    fault: string;
}

export interface IHomeGISLayer {
    overlays: any[];
    picUrlObj?: IPicStatusUrl;
    popup?: any;
}

export interface IHomeRealTimeRequest {
    requestInterval: number;
    pointsUrl: {
        tw: {
            online: string;
            offline: string;
            fault: string;
        };
        qj: {
            online: string;
            offline: string;
            fault: string;
        };
        kk: {
            online: string;
            offline: string;
            fault: string;
        };
        dj: {
            online: string;
            offline: string;
            fault: string;
        };
        cim: {
            online: string;
            offline: string;
            fault: string;
        };
        park: {
            online: string;
            offline: string;
            fault: string;
        };
    };
}

export interface IAnimateLineAddParams {
    //线
    lines: {
        color: string | []; //线色
        width: number; // 线宽
        style: string; //线样式  "solid"|"dash"
        paths: Array<Array<[number, number]>>; //经纬度坐标点集
    };
    repeat?: boolean; //是否重复动画
    speed?: number; //动画速度 [1,1000]
    type: string; // 线图层标识
}

export interface IAnimateLineDelParams {
    types: Array<string>; //图层类型名
}
interface TooltipStyle {
    position?: String;
    backgroundColor?: String;
    color?: String;
    fontSize?: String;
    lineHeight?: String;
}

export interface IODDataParams {
    url?: string; // 迁徙点图层数据url
    pointData?: []; // 迁徙点数据
    label?: string; // 图层标签
    showCenter?: boolean; //是否显示到地图中心
    showPointLabel?: boolean; //是否显示od点文字
    id: string; //id名称
    showLabel: boolean; //
    tooltipStatus?: boolean; //是否显示提示框
    tooltipStyle?: TooltipStyle;
    datas: Array<{ from: string; to: string; value: number; type: string }>; // 迁徙线数据
    // 迁徙线样式
    lineStyle?: object; //对象内可用属性参见 https://echarts.apache.org/zh/option.html#series-lines.lineStyle
    // 文本样式
    textStyle?: object; //对象内可用属性参见 https://echarts.apache.org/zh/option.html#series-lines.label
    // 迁徙线上动态点样式
    effectStyle?: object; //对象内可用属性参见 https://echarts.apache.org/zh/option.html#series-lines.effect
}
